<div [class]="getCardClass()" [ngStyle]="getCardStyle()">
  <div class="stat-content">
    <div class="stat-info">
      <!-- Enhanced mode: Title with info icon and tooltip -->
      <div class="stat-title-container" *ngIf="enhancedMode">
        <p class="stat-title">{{ title }}</p>
        <div class="info-icon" 
             *ngIf="tooltip"
             (mouseenter)="onTooltipHover($event, tooltip)"
             (mouseleave)="onTooltipLeave($event)"
             (touchstart)="onTooltipClick($event, tooltip)"
             tabindex="0">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 12.833c-3.225 0-5.833-2.608-5.833-5.833S3.775 1.167 7 1.167 12.833 3.775 12.833 7 10.225 12.833 7 12.833z" fill="currentColor"/>
            <path d="M7 3.5c-.483 0-.875.392-.875.875S6.517 5.25 7 5.25s.875-.392.875-.875S7.483 3.5 7 3.5zM7 6.125c-.483 0-.875.392-.875.875v2.625c0 .483.392.875.875.875s.875-.392.875-.875V7c0-.483-.392-.875-.875-.875z" fill="currentColor"/>
          </svg>
        </div>
      </div>
      
      <!-- Simple mode: Regular title -->
      <p class="stat-title" *ngIf="!enhancedMode">{{ title }}</p>
      
      <h3 class="stat-value" [ngStyle]="getValueStyle()">{{ value }}</h3>
      
      <!-- Enhanced mode: Percentage and period text -->
      <div class="stat-enhanced-info" *ngIf="enhancedMode">
        <p class="stat-percentage-period" *ngIf="percentage && periodText">{{ percentage }} {{ periodText }}</p>
      </div>
      
      <!-- Simple mode: Change text -->
      <p class="stat-change" *ngIf="!enhancedMode && change" [ngClass]="'change-' + changeType">
        {{ change }}
      </p>
    </div>
    <div class="stat-icon">
      <img [src]="icon || 'assets/images/stats-card-bg.png'" 
           [alt]="title + ' icon'"
           [class]="iconClass"
           [ngStyle]="iconStyle">
    </div>
  </div>
</div>
